import { AutoComplete } from 'm2m.components';
import _ from 'lodash';
import { BancoResponse } from 'common/genericTypes';
import { addCpfCnpjMask } from 'utils/mask';
import { TextField as MUITextField } from '@material-ui/core';

interface Props {
  bancos: Array<BancoResponse>;
  banco: BancoResponse | null;
  label?: string;
  onChange: (banco: BancoResponse | null) => void;
  error?: boolean;
  disabled?: boolean;
}

const BancoAutoComplete: React.FC<Props> = (props) => {
  const { bancos, banco, label = 'Banco *', onChange, error, disabled = false } = props;

  const bancosFilter = (value: string) =>
    bancos.filter(
      (b) =>
        b.code.includes(value) ||
        b.fullname.toLocaleLowerCase().includes(value) ||
        b.cnpj.includes(value) ||
        b.shortname.toLocaleLowerCase().includes(value)
    );

  return (
    <AutoComplete
      label={label}
      options={bancos}
      getOptionLabel={(option: BancoResponse) => `${option.code} - ${option.shortname}`}
      value={banco}
      onChange={onChange}
      filterOptions={(_options: Array<BancoResponse>, state) => bancosFilter(state.inputValue.toLocaleLowerCase())}
      helperText={banco ? `${addCpfCnpjMask(banco.cnpj)}` : ''}
      disabled={disabled}
      renderInput={(params) => (
        <MUITextField {...params} label={label} variant="outlined" placeholder={'Pesquisar...'} error={error} disabled={disabled} />
      )}
    />
  );
};

export default BancoAutoComplete;
